import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { COMPONENT_REGISTRY, MAIN_ROUTES } from 'common/config/routes.config';

import WelcomeSection from '../../components/welcome-section/WelcomeSection';
import NavigationSection from '../../components/navigation-section/NavigationSection';

import './Home.scss';
import { mailToSupport } from 'common/config/app.config';
import { ROLES_AND_ACCESS_MOCK_DATA } from 'common/mock-data';
import { useRolesAndAccess } from 'common/providers/AccessProvider';
type HomeProps = {
    userName: string;
    hasAccess: boolean;
};

const Home: FC<HomeProps> = ({ userName, hasAccess }: HomeProps) => {
    const { featuresHierarchy } = useRolesAndAccess();

    const navigate = useNavigate();
    const getDefaultPath = (): string => {
        if (
            featuresHierarchy &&
            featuresHierarchy.length > 0 &&
            featuresHierarchy[0].subRoutes &&
            featuresHierarchy[0].subRoutes.length > 0
        ) {
            return featuresHierarchy[0].subRoutes[0].path ?? '/';
        }
        return featuresHierarchy[0]?.path ?? '/';
    };
    const handleNavigation = () => {
        if (hasAccess) navigate(getDefaultPath());
        else {
            window.location.href = mailToSupport;
        }
    };

    return (
        <div className="home-container">
            <WelcomeSection userName={userName} hasAccess={hasAccess} />
            <NavigationSection hasAccess={hasAccess} onNavigation={handleNavigation} />
        </div>
    );
};

export default Home;
